module.exports = __webpack_public_path__ + "static/media/alerts.1de9fe84.png";